import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';

// Shared image-or-initial placeholder. When `image` is provided it renders the image
// (object-fit cover); otherwise it renders a themed gradient with the first letter of
// `name`. Single source of truth for the gradient/initial fallback — reused by
// PresencePanel and the news cards (NewsGrid / NewsBar) so the surfaces never drift.
// Callers own the box dimensions via `style` (width/height/borderRadius/aspectRatio).
// `color` overrides the ambient theme.primary — for a surface that must read as a
// different context colour than the one it's physically mounted in (e.g. GroupsColumn's
// mauve cards on the blue Locality front page).
const InitialPlaceholder = ({ name, image = null, fontSize = '2rem', style = {}, color = null }) => {
  const theme = useTheme();
  const gradientColor = color || theme.primary;
  const initial = (name || '?').trim().charAt(0).toUpperCase();
  return (
    <div style={{
      flexShrink: 0,
      background: `linear-gradient(135deg, ${gradientColor}, ${gradientColor}aa)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
      color: '#fff', fontWeight: 700, fontSize,
      ...style
    }}>
      {image
        ? <img src={image} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : initial}
    </div>
  );
};

export default InitialPlaceholder;
